import React from "react";
import Phobox from './Phobox';
import {BrowserRouter as Router,Route,Link} from 'react-router-dom'
function MainContent() {

    return (
        <div>
        <div className="preloader-area">
		<div className="loader-box">
			<div className="loader"></div>
		</div>
	</div>
    <hr></hr>
<section id="home" className="home-banner-area">

        <div className="container">	
		
            <div className="row fullscreen d-flex align-items-center">
                <div className="banner-content col-lg-6 col-md-12 justify-content-center ">	
				<div className="panel">
                    <h1 className="wow fadeInUp" data-wow-duration="1s" data-wow-delay="1.7s">Damla Eker</h1>
                    <div className="designation mb-50 wow fadeInUp" data-wow-duration="1s" data-wow-delay="2.1s">
                        Software 
					<span className="designer"> Developer</span>
                    </div>
                    <a data-toggle="modal" data-target="#registration-login-form-popup" href="#" className="primary-btn" data-text="Contact Me">
                        <span>C</span>
                        <span>o</span>
                        <span>n</span>
                        <span>t</span>
                        <span>a</span>
                        <span>c</span>
                        <span>t</span>
                        <span> &nbsp; </span>
                        <span>M</span>
                        <span>e</span>
                    </a>
				
                </div>

                {/* <div className="banner-img col-lg-6 col-md-6 align-self-end">
                    <img className="img-fluid" src="img/DamlaProfile2.png" alt=""></img>	
                    		</div> */}
                </div>
            </div>
            </div>
            
            </section>

		<section className="section-bg work-area section-gap-top section-gap-bottom-90" id="work">
		<div className="container">
			<div className="row d-flex justify-content-between align-items-end mb-80">
				<div className="col-lg-6">
					<div className="section-title">
						<h2>Latest Projects</h2>
						<p>A selection of my latest projects.</p>
					</div>
				</div>

				<div className="col-lg-6">
					{/* <div className="filters">
						<ul>
							<li className="active" data-filter=".all">All Categories</li>
							<li data-filter=".branding">Branding</li>
							<li data-filter=".creative">Creative Work</li>
							<li data-filter=".web-design">Web Design</li>
						</ul>
					</div> */}
				</div>
			</div>

			<div className="filters-content">
				<div className="row grid">
			
			
					<div className="single-work col-lg-4 col-md-6 col-sm-12 all branding web-design wow fadeInUp" data-wow-duration="2s" data-wow-delay="0.4s">
						<div className="relative">
							<div className="thumb">
								<div className="overlay overlay-bg"></div>
								<img className="image img-fluid" src="img/portfolio/cover/wizard1.png" alt=""></img>
							</div>
							<div className="middle">
								<h4>LAST MAGE STANDING</h4>
								<div className="cat">Multiplayer HTML5 Game</div>
							</div>
							
							<a className="overlay"data-toggle="modal" data-target="#lastMageStandingPopup" href="#"></a>
						</div>
					</div>

					<div className="single-work col-lg-4 col-md-6 col-sm-12 all web-design branding wow fadeInUp" data-wow-duration="2s" data-wow-delay="0.2s">
						<div className="relative">
							<div className="thumb">
								<div className="overlay overlay-bg"></div>

								<img className="image img-fluid" src="img/portfolio/cover/slot1.png" alt=""></img>
				
							</div>
							<div className="middle">
								<h4>Slot Games</h4>
								<div className="cat">HTML5</div>
							</div>
							<a className="overlay"data-toggle="modal" data-target="#slotGamesPopup" href="#" ></a>
						</div>
					</div>
			
					<div className="single-work col-lg-4 col-md-6 col-sm-12 all creative wow fadeInUp" data-wow-duration="2s">
						<div className="relative">
							<div className="thumb">
								<div className="overlay overlay-bg"></div>
								<img className="image img-fluid" src="img/portfolio/cover/BlastArena1.png" alt=""></img>
							</div>
							<div className="middle">
								<h4>BLAST ARENA</h4>
								<div className="cat">Mobile integration</div>
							</div>					
							<a className="overlay"data-toggle="modal" data-target="#blastArenaPopup" href="#"></a>
						</div>
					</div>
				
					<div className="single-work col-lg-4 col-md-6 col-sm-12 all creative wow fadeInUp" data-wow-duration="2s">
						<div className="relative">
							<div className="thumb">
								<div className="overlay overlay-bg"></div>
								<img className="image img-fluid" src="img/portfolio/cover/image7.png" alt=""></img>
							</div>
							<div className="middle">
								<h4>Phobox</h4>
								<div className="cat">VR</div>
							</div>					
							<a className="overlay"data-toggle="modal" data-target="#phoboxPopup" href="#" ></a>
						
						</div>
					</div>
		

					<div className="single-work col-lg-4 col-md-6 col-sm-12 all web-design wow fadeInUp" data-wow-duration="2s" data-wow-delay="0.6s">
						<div className="relative">
							<div className="thumb">
								<div className="overlay overlay-bg"></div>
								<img className="image img-fluid" src="img/portfolio/cover/Flow1.png" alt=""></img>
							</div>
							<div className="middle">
								<h4>REAL ESTATE VR</h4>
								<div className="cat">VR</div>
							</div>
							<a className="overlay" href="portfolio-details-realestate.html"></a>
							<a className="overlay"data-toggle="modal" data-target="#realEstatePopup" href="#" ></a>
							
						</div>
					</div>

					<div className="single-work col-lg-4 col-md-6 col-sm-12 all branding wow fadeInUp" data-wow-duration="2s" data-wow-delay="0.2s">
						<div className="relative">
							<div className="thumb">
								<div className="overlay overlay-bg"></div>
								<img className="image img-fluid" src="img/portfolio/cover/poseplay1.png" alt=""></img>
							</div>
							<div className="middle">
								<h4>PosePlay.tech</h4>
								<div className="cat">Website</div>
							</div>
							<a className="overlay"data-toggle="modal" data-target="#poseplayPopup" href="#" ></a>
							
						</div>
					</div>
					<div className="single-work col-lg-4 col-md-6 col-sm-12 all branding wow fadeInUp" data-wow-duration="2s" data-wow-delay="0.2s">
						<div className="relative">
							<div className="thumb">
								<div className="overlay overlay-bg"></div>
								<img className="image img-fluid" src="img/portfolio/cover/patientShoes.png" alt=""></img>
							</div>
							<div className="middle">
								<h4>Patient Shoes</h4>
								<div className="cat">Desktop Application</div>
							</div>
							<a className="overlay"data-toggle="modal" data-target="#patientShoesPopup" href="#" ></a>
							
						</div>
					</div>
					<div className="single-work col-lg-4 col-md-6 col-sm-12 all branding wow fadeInUp" data-wow-duration="2s" data-wow-delay="0.2s">
						<div className="relative">
							<div className="thumb">
								<div className="overlay overlay-bg"></div>
								<img className="image img-fluid" src="img/portfolio/cover/HubCover.png" alt=""></img>
							</div>
							<div className="middle">
								<h4>PWC Hub</h4>
								<div className="cat">Desktop Application</div>
							</div>
							<a className="overlay"data-toggle="modal" data-target="#hubPopup" href="#" ></a>
							
						</div>
					</div>
					<div className="single-work col-lg-4 col-md-6 col-sm-12 all branding wow fadeInUp" data-wow-duration="2s" data-wow-delay="0.2s">
						<div className="relative">
							<div className="thumb">
								<div className="overlay overlay-bg"></div>
								<img className="image img-fluid" src="img/portfolio/cover/HologramCover.png" alt=""></img>
							</div>
							<div className="middle">
								<h4>Hologramsoft.com</h4>
								<div className="cat">Website</div>
							</div>
							<a className="overlay"data-toggle="modal" data-target="#hologramPopup" href="#" ></a>
							
						</div>
					</div>

					<div className="single-work col-lg-4 col-md-6 col-sm-12 all branding wow fadeInUp" data-wow-duration="2s" data-wow-delay="0.2s">
						<div className="relative">
							<div className="thumb">
								<div className="overlay overlay-bg"></div>
								<img className="image img-fluid" src="img/portfolio/cover/NBCUCover.png" alt=""></img>
							</div>
							<div className="middle">
								<h4>NBCU</h4>
								<div className="cat">IOS Application</div>
							</div>
							<a className="overlay"data-toggle="modal" data-target="#nbcuPopup" href="#" ></a>
							
						</div>
					</div>

					{/* <div className="single-work col-lg-4 col-md-6 col-sm-12 all branding wow fadeInUp" data-wow-duration="2s" data-wow-delay="0.2s">
						<div className="relative">
							<div className="thumb">
								<div className="overlay overlay-bg"></div>
								<img className="image img-fluid" src="img/portfolio/cover/heroCover.png" alt=""></img>
							</div>
							<div className="middle">
								<h4>Hero</h4>
								<div className="cat">Mobile Game</div>
							</div>
							<a className="overlay"data-toggle="modal" data-target="#heroPopup" href="#" ></a>
							
						</div>
					</div> */}

					<div className="single-work col-lg-4 col-md-6 col-sm-12 all branding wow fadeInUp" data-wow-duration="2s" data-wow-delay="0.2s">
						<div className="relative">
							<div className="thumb">
								<div className="overlay overlay-bg"></div>
								<img className="image img-fluid" src="img/portfolio/cover/saCover.png" alt=""></img>
							</div>
							<div className="middle">
								<h4>SACA</h4>
								<div className="cat">IOS Application</div>
							</div>
							<a className="overlay"data-toggle="modal" data-target="#saPopup" href="#" ></a>
							
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
            
    <section id="about-myself" className=" about-area section-gap">
		<div className="container">
			<div className="row align-items-center justify-content-between">
				<div className="col-lg-6 about-left">
					<img className="img-fluid" src="img/about-me.jpg" alt=""></img>
				</div>
				<div className="col-lg-5 col-md-12 about-right">
					<div className="section-title">
						<h2>About Me</h2>
					</div>
					<div className="mb-50 wow fadeIn" data-wow-duration=".8s">
					<p>I graduated in 2015 from Kultur University with a degree in Computer Engineering.</p>

					<p>I am a proven developer of cutting edge technologies, and have experience in delivering on very tight schedules. The medical VR application I developed, Phobox, was completely new in its field and I utilised my skills across three different platforms to deliver a product that worked seamlessly in VR and was made to the exact specifications of the doctors that had designed the product.</p>

					<p>I have proven myself as an expert developer in many platforms including mobile apps, HTML5 websites, multiplatform games, traditional analysis software, desktop applications and backend integration.</p>

					<p>I am an enthusiastic worker and a quick learner, I easily adopt new skills and can offer my services to projects with a wide variety of requirements.</p>
			
					</div>
					<a href="https://www.linkedin.com/in/damla-eker-49562bb9/" target="_blank" className="primary-btn white" data-text="LinkedIn">
						<span>L</span>
						<span>i</span>
						<span>n</span>
						<span>k</span>
						<span>e</span>
						<span>d</span>
						<span>i</span>
						<span>n</span>
						
					</a>
					
					{/* <a href="DamlaEker-CV1.pdf" target="_blank" className="primary-btn" data-text="Resume">
						<span>R</span>
						<span>e</span>
						<span>s</span>
						<span>u</span>
						<span>m</span>
						<span>e</span>
					</a> */}
				</div>
			</div>
		</div>
	</section>
    <div className="modal fade" id="registration-login-form-popup" tabindex="-1" role="dialog" aria-labelledby="registration-login-form-popup" aria-hidden="true">
		<div className="modal-dialog window-popup registration-login-form-popup" role="document">
			<div className="modal-content">			
				<div className=" contact-area modal-body">
					<button type="button" className="close" data-dismiss="modal" aria-label="Close">
          				<span aria-hidden="true">&times;</span>
        			</button>
					<div className="registration-login-form  ">					
						<div className="tab-content">
							<div className="tab-pane active " id="home1" role="tabpanel" data-mh="log-tab">								
								<div className="comment-form ">
									<div className="designation" >
									<h4>CONTACT ME</h4>									
									</div>								  
									<form className="form-area "  action="send" method="post">
										<div className="form-group form-inline">
											<div className="form-group col-lg-6 col-md-12 name">
												<input type="text"  name="name" className="common-input mb-20 form-control border rounded" id="name" placeholder="Enter Name" onocus="this.placeholder = ''" onblur="this.placeholder = 'Name'"></input>
											</div>

											<div className="form-group col-lg-6 col-md-12 email">
												<input type="email" name="email" className="common-input mb-20 form-control border rounded" id="email" placeholder="Enter email address" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Enter email address'"></input>
											</div>
										</div>
										
										<div className="form-group">
											<textarea className="form-control mb-10 border rounded" rows="5" name="message" placeholder="Message" onfocus="this.placeholder = ''" onblur="this.placeholder = 'Messege'"
											 required=""></textarea>
										</div>
										<div className="contactButton" >
										<button type="submit" className="primary-btn" style={{float: 'center'}} data-text="Send Email">
											<span>S</span>
											<span>e</span>
											<span>n</span>
											<span>d</span>
											<span> </span>
											<span>E</span>
											<span>m</span>
											<span>a</span>
											<span>i</span>
											<span>l</span>
											
										</button>
										</div>
									</form>
								</div>
										
									</div>
								</div>
							</div>
	
							
						</div>
					</div>
				</div>
			</div>



    {/* <section id="job-history"className=" section-bg job-area section-gap-top section-gap-bottom-90">
		<div className="container">
			<div className="row d-flex">
				<div className="col-lg-12">
					<div className="section-title">
						<h2>Job History</h2>
						<p>If you are looking at blank cassettes on the web, you may be very confused at the difference in price. You may see
							some for as low as $.17 each.</p>
					</div>
				</div>
			</div>

			<div className="row">
				<div className="col-lg-6">
					<div className="single-job">
						<div className="top-sec d-flex justify-content-between">
							<div className="top-left">
								<h4>Freelance Software Developer</h4>
								<p>London, UK</p>
							</div>
							<div className="top-right">
								<a href="#" className="primary-btn" data-text="Jul '15 to Present">
									<span>M</span><span>a</span><span>r</span>
									<span>'</span><span>1</span><span>8</span>
									<span>t</span><span>o</span>
									<span>P</span><span>r</span><span>e</span><span>s</span><span>e</span><span>n</span><span>t</span>
								</a>
							</div>
						</div>
						<div className="bottom-sec wow fadeIn" data-wow-duration="2s">
							
						</div>
					</div>
				</div>

				<div className="col-lg-6">
					<div className="single-job">
						<div className="top-sec d-flex justify-content-between">
							<div className="top-left">
								<h4>Self-Employed Software Developer</h4>
								<p>Istanbul</p>
							</div>
							<div className="top-right">
								<a href="#" className="primary-btn" data-text="Nov '15 to Feb '18">
								<span>N</span><span>o</span><span>v</span>
									<span>'</span><span>1</span><span>5</span>
									<span>t</span><span>o</span>
									<span>F</span><span>e</span><span>b</span><span> </span><span>'1</span><span>8</span>
								</a>
							</div>
						</div>
						<div className="bottom-sec wow fadeIn" data-wow-duration="2s" data-wow-delay="0.2s">
							During first years of her professional work life Damla took important roles in various projects. 
						</div>
					</div>
				</div>


				<div className="col-lg-6">
					<div className="single-job">
						<div className="top-sec d-flex justify-content-between">
							<div className="top-left">
								<h4>Intern Software Developer</h4>
								<p>Ciner Publishing Holding Company, Istanbul</p>
							</div>
							<div className="top-right">
								<a href="#" className="primary-btn" data-text="Aug '15 to Sep '15">
									<span>A</span><span>u</span><span>g</span>
									<span>'</span><span>1</span><span>5</span> <span> </span> 
									<span>t</span><span>o</span> <span> </span>
									<span>S</span><span>e</span><span>p</span><span> </span><span>'1</span><span>5</span>
								</a>
							</div>
						</div>
						<div className="bottom-sec wow fadeIn" data-wow-duration="2s" data-wow-delay="0.6s">
						At Ciner Publishing Holding Damla learned to use and develop for the SAP platform.
						</div>
					</div>
				</div>

                <div className="col-lg-6">
					<div className="single-job">
						<div className="top-sec d-flex justify-content-between">
							<div className="top-left">
								<h4>Intern Software Developer</h4>
								<p>Betik Informatics, Istanbul</p>
							</div>
							<div className="top-right">
								<a href="#" className="primary-btn" data-text="Jun '14 to Jul '14">
									<span>J</span><span>u</span><span>n</span><span> </span>
									<span>'</span><span>1</span><span>4</span><span> </span>
									<span>t</span><span>o</span> <span> </span>
									<span>J</span><span>u</span><span>l</span><span> </span><span>'</span><span>1</span><span>4</span>
								</a>
							</div>
						</div>
						<div className="bottom-sec wow fadeIn" data-wow-duration="2s" data-wow-delay="0.4s">
							Damla developed and supported live web sites during her internship at Betik Informetics.
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>*/}

</div> 
		  
        );}
            
export default MainContent